<!-- Only render if item exists -->
<ng-container *ngIf="item">
  <!-- ResetPassword link -->
  <!--<a *ngIf="item.RoutingUrl.indexOf('Account/ResetPassword') >= 0" mat-list-item [ngStyle]="{'padding-left': (depth * 12) + 'px'}" [href]="item.RoutingUrl" target="_blank" (click)="onItemSelected(item)"
     [ngClass]="{'active': item.RoutingUrl ? router.isActive(item.RoutingUrl, true): false, 'expanded': expanded}"
     class="menu-list-item">
    {{item.Name}}
    <span fxFlex *ngIf="item.children && item.children.length">
      <span fxFlex></span>
      <mat-icon [@indicatorRotate]="expanded ? 'expanded': 'collapsed'">
        expand_more
      </mat-icon>
    </span>
  </a>-->

  <!-- Regular navigation link -->
  <a mat-list-item
     [ngStyle]="{'padding-left': (depth * 12) + 'px'}"
     [routerLink]="item.RoutingUrl ? [item.RoutingUrl] : []"
     (click)="onItemSelected(item)"
     [ngClass]="{
            'active': item.RoutingUrl ? router.isActive(item.RoutingUrl, true) : false,
            'expanded': expanded
              }"
     class="menu-list-item">
    {{ item.Name }}
    <span fxFlex *ngIf="item.children?.length">
      <span fxFlex></span>

      <mat-icon [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'">
        expand_more
      </mat-icon>
    </span>
  </a>

  <!-- IMPORTANT: preserve subtree -->
  <div [hidden]="!expanded">

    <menu-list-item *ngFor="let child of item.children; trackBy: trackById"
                    [item]="child"
                    [depth]="depth + 1">

    </menu-list-item>

  </div>
</ng-container>
